enum AccountPlanType {
  PLAN_NONE = "PLAN_NONE",
  PLAN_A = "PLAN_A",
  PLAN_B = "PLAN_B",
  PLAN_C = "PLAN_C",
}

export default AccountPlanType;
